import React from 'react';
import { Button, Drawer, Form } from 'src/components/Antd';
import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const AdvancedFilter = (props: any) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const {
    resetAll,
    handleOnSubmit,
    visible,
    onClose,
    title,
    onFinish,
    initialValues,
    form,
    children,
  } = props;
  return (
    <Drawer
      getContainer={false}
      footer={
        <div className={css.footerContainer}>
          <Button className={css.footerClear} onClick={resetAll}>
            {getI18n('general.advanceFilter.clear_all')}
          </Button>
          <Button className={css.footerConfirm} onClick={handleOnSubmit}>
            {getI18n('general.advanceFilter.apply')}
          </Button>
        </div>
      }
      noContainerStyle
      className={css.drawer}
      visible={visible}
      onClose={onClose}
      title={title || getI18n('general.advanceFilter.customer_filters')}
      width={420}>
      {/* <button
        onClick={() => {
          console.log(form1.getFieldValue('tagFilter'));
        }}>
        123
      </button> */}
      <Form
        onFinishFailed={(e) => {
          console.log('failed', e);
        }}
        onFinish={onFinish}
        layout={'vertical'}
        initialValues={initialValues}
        form={form}>
        {children}
      </Form>
    </Drawer>

    //
  );
};
export default AdvancedFilter;
